import { type Tuple } from "@/types";
import { type FrameName } from "../entities/config";

export enum BeachNeighbourType {
	Water = 0,
	Land = 1,
}

enum BeachSegmentType {
	TOP_SIDE = 2 ** 0,
	RIGHT_SIDE = 2 ** 1,
	BOTTOM_SIDE = 2 ** 2,
	LEFT_SIDE = 2 ** 3,
	TOP_RIGHT_INNER_CORNER = 2 ** 4,
	TOP_LEFT_INNER_CORNER = 2 ** 5,
	BOTTOM_RIGHT_INNER_CORNER = 2 ** 6,
	BOTTOM_LEFT_INNER_CORNER = 2 ** 7,
	TOP_RIGHT_OUTER_CORNER = 2 ** 8,
	TOP_LEFT_OUTER_CORNER = 2 ** 9,
	BOTTOM_RIGHT_OUTER_CORNER = 2 ** 10,
	BOTTOM_LEFT_OUTER_CORNER = 2 ** 11,
}

// exported from https://gbsc.findl.sk
const config = new Map<number, number>([
	[512, 1],
	[1, 2],
	[256, 4],
	[768, 5],
	[8, 8],
	[41, 10],
	[264, 12],
	[2, 16],
	[514, 17],
	[19, 18],
	[10, 24],
	[59, 26],
	[2048, 32],
	[2560, 33],
	[2049, 34],
	[2304, 36],
	[2816, 37],
	[2050, 48],
	[2562, 49],
	[2067, 50],
	[4, 64],
	[516, 65],
	[5, 66],
	[260, 68],
	[772, 69],
	[140, 72],
	[173, 74],
	[396, 76],
	[70, 80],
	[582, 81],
	[87, 82],
	[206, 88],
	[255, 90],
	[1024, 128],
	[1536, 129],
	[1025, 130],
	[1280, 132],
	[1792, 133],
	[1032, 136],
	[1065, 138],
	[1288, 140],
	[3072, 160],
	[3584, 161],
	[3073, 162],
	[3328, 164],
	[3840, 165],
]);

export const getCorrectBeachFrameName = (
	neighbours: Tuple<BeachNeighbourType, 8>,
): FrameName | null => {
	const segments = new Set<BeachSegmentType>();

	/*
	 *
	 *	0 1 2
	 *	3 X 4
	 *	5 6 7
	 *
	 */

	if (neighbours[1]) segments.add(BeachSegmentType.TOP_SIDE);
	if (neighbours[3]) segments.add(BeachSegmentType.LEFT_SIDE);
	if (neighbours[4]) segments.add(BeachSegmentType.RIGHT_SIDE);
	if (neighbours[6]) segments.add(BeachSegmentType.BOTTOM_SIDE);

	if (neighbours[1] && neighbours[3])
		segments.add(BeachSegmentType.TOP_LEFT_INNER_CORNER);
	if (neighbours[1] && neighbours[4])
		segments.add(BeachSegmentType.TOP_RIGHT_INNER_CORNER);
	if (neighbours[6] && neighbours[3])
		segments.add(BeachSegmentType.BOTTOM_LEFT_INNER_CORNER);
	if (neighbours[6] && neighbours[4])
		segments.add(BeachSegmentType.BOTTOM_RIGHT_INNER_CORNER);

	if (neighbours[0] && !neighbours[1] && !neighbours[3])
		segments.add(BeachSegmentType.TOP_LEFT_OUTER_CORNER);
	if (neighbours[2] && !neighbours[1] && !neighbours[4])
		segments.add(BeachSegmentType.TOP_RIGHT_OUTER_CORNER);
	if (neighbours[5] && !neighbours[3] && !neighbours[6])
		segments.add(BeachSegmentType.BOTTOM_LEFT_OUTER_CORNER);
	if (neighbours[7] && !neighbours[4] && !neighbours[6])
		segments.add(BeachSegmentType.BOTTOM_RIGHT_OUTER_CORNER);

	const segmentValue = Array.from(segments).reduce(
		(acc: number, value: BeachSegmentType): number => acc + value,
		0,
	);

	return config.has(segmentValue)
		? (`Beach_${config.get(segmentValue)}.png` as FrameName)
		: null;
};
